import React, { useCallback } from "react";
import ItemComponent from "./ItemComponent";
import update from "immutability-helper";
import { ItemTypes } from "../Internal/ItemTypes";


const RadioComponent = ({ config, onChange }) => {
	let items = config.extraSettings?.items || [ {} ];

	const updateItems = updateFunction => {
		const newConfig = {
			extraSettings: {
				items: [ ...items ],
				dataSource: "Static",
				storage: "Id",
				identity: "text"
			}
		};
		updateFunction(newConfig.extraSettings.items);
		onChange(newConfig);
	};

	const onItemChange = (index, newValue) => updateItems(items => items[index].text = newValue);
	const deleteItem = index => updateItems(items => items.splice(index, 1));
	const addItem = () => updateItems(items => items.push({ text: "" }));
	const moveItem = useCallback(
		(dragIndex, hoverIndex) => {
			const dragItem = items[dragIndex];
			const updatedItems =
				update(items, {
					$splice: [
						[ dragIndex, 1 ],
						[ hoverIndex, 0, dragItem ],
					],
				});
			items = updatedItems;
			updateItems((items => items));
		},
		[ items ],
	);

	return (
		<>
			{items.map((item, index) => {
				return (
					<ItemComponent
						key={index}
						item={item}
						index={index}
						itemType={ItemTypes.RADIO_ITEM_COMPONENT}
						onItemChange={onItemChange}
						deleteItem={deleteItem}
						addItem={addItem}
						moveItem={moveItem}
						totalItems={items.length}
					>
						<input type="radio" disabled={true} />
					</ItemComponent>
				);
			})}
      Users may only select one option, when using radio buttons.
		</>
	);
};

RadioComponent.information = {
	type: "radio",
	name: "Radio Buttons"
};

export default RadioComponent;
